import { apiRequest } from "../index";

export const getAllOffers = async ({ page = 1, limit = 10, ...filters }) => {
  const params = new URLSearchParams();
  params.append("page", page);
  params.append("limit", limit);

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined) {
      params.append(key, value);
    }
  });

  return apiRequest(`/api/admin/offers?${params.toString()}`, "GET");
};


export const getOfferById = async (offerId) => {
  return apiRequest(`/api/admin/offers/${offerId}`, "GET");
};

export const updateOfferStatus = async (offerId, data) => {
  return apiRequest(`/api/admin/offers/status/${offerId}`, "PUT", data );
};

export const addOfferForAll = async (formData) => {
  return apiRequest(`/api/admin/offers`, "POST", formData,true);
};

export const updateVisibility = async (offerId, data) => {
  return apiRequest(`/api/admin/offers/visibility/${offerId}`, "PUT",  data);
};